import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/customer-dashboard/page.tsx");
